<template>
	<div class="skel-wrapper">
		<div class="skel-header sh1">
			<div class="skel-spacer ss1"></div>
			<div class="skel-spacer ss1"></div>
		</div>
		<div class="skel-header sh2">
			<div class="skel-spacer ss2"></div>
		</div>				
		<div class="skel-container">

		</div>
		<div class="skel-footer">
			<div class="skel-row">
				<div class="skel-spacer ss3"></div>
				<div class="skel-spacer ss1"></div>
			</div>
			<div class="skel-spacer ss1"></div>
		</div>		
	</div>
</template>
   
<style scoped>
	.skel-wrapper {
		min-height: 25rem;
		margin: 2rem 0;
		position:relative;
	}
	.skel-header {
		min-height: 2.5rem;
		width: 100%;
		padding-bottom: var(--spacing-2xl, 2rem);
	}
	.skel-header.sh1 {
		display: flex;
		justify-content: space-between;
	}	
	.skel-header.sh2 {
		display: flex;
		justify-content:center;
	}	
	.skel-spacer {
		min-width: 15rem;
		height: 2rem;
		border:1px solid #d9d9d9;
		background-color: #d9d9d9;
		border-radius: .25rem;
	}
	.skel-spacer.ss1 {
		width: 15rem;
		margin-bottom: 1rem;
	}	
	.skel-spacer.ss2 {
		width: 30rem;
		margin-bottom: 1rem;
	}	

	.skel-spacer.ss3 {
		width: 5rem;
		margin-bottom: 1rem;
	}	

	.skel-container {
		min-width: 22.75rem;
		min-height: 19rem;
		border: 1px solid var(--border-color-input-Border, #d9d9d9);
		background-color: #d9d9d9;
		/* background: var(--surfaces-surface-tertiary, #FAFAFA); */
	}

	.skel-footer {
		min-height: 2.5rem;
		background-color: #fff;
		width: 100%;
		margin-top: 2rem;
	}
	.skel-row {
		display: flex;
	}
	.skel-row .skel-spacer {
		margin-right: 1rem;
		min-width: unset;
	}

.skel-wrapper::after {
	content: "";
	position: absolute;
	top: 0;
	bottom: 0;

	/* Width of the moving highlight */
	width: 120px;

	/*
	* Make the wave fade on both sides.
	* The middle is the brighter portion.
	*/
	background: linear-gradient(
	90deg,
	transparent 0%,
	rgba(255, 255, 255, 0.0) 10%,
	rgba(255, 255, 255, 0.65) 50%,
	rgba(255, 255, 255, 0.0) 90%,
	transparent 100%
	);

	transform: translateX(-150px);

	animation: skeleton-wave 3s linear infinite;

	pointer-events: none;
}

@keyframes skeleton-wave {
  from {
    transform: translateX(-150px);
  }

  to {
    transform: translateX(calc(100vw + 150px));
  }
}
</style>